import Navigation from "../../../../components/header";
import { Container } from "@mui/material";

const Sara313Report = () => {
    return (
        <>
            <Navigation></Navigation>
			<Container maxWidth="lg" className="route-container">
			{/* <iframe title="SARA313Report" width="1140" height="541.25" src="https://app.powerbi.com/reportEmbed?reportId=4fd6283d-092e-4799-a65f-75070188eb66&autoAuth=true&ctid=3d903043-2b47-4eb6-ba60-a27fe7950ef2" frameBorder="1"></iframe> */}
			</Container>
            
        </>
    );
};

export default Sara313Report;